import crypto from "crypto";

// const CBD_SALT = process.env.CBD_SALT
//   ? process.env.CBD_SALT
//   : "XYVLMAXBY0X7AV9A";
const PASSWORD_SALT = process.env.PASSWORD_SALT
  ? process.env.PASSWORD_SALT
  : "#ncrypt3dH@sh1ng";

export function encrypt(data, encryptionKey = "XYVLMAXBY0X7AV9A") {
  const secret = Buffer.from(encryptionKey, "utf8");
  const key = secret;
  const iv = secret;

  const cipher = crypto.createCipheriv("aes-128-cbc", key, iv);
  let crypted = cipher.update(data, "utf8", "binary");
  crypted += cipher.final("binary");
  crypted = Buffer.from(crypted, "binary").toString("base64");

  return crypted;
}

export function decrypt(data, encryptionKey = "XYVLMAXBY0X7AV9A") {
  const secret = Buffer.from(encryptionKey, "utf8");
  const key = secret;
  const iv = secret;

  const decrypt = Buffer.from(data, "base64").toString("binary");
  const decipher = crypto.createDecipheriv("aes-128-cbc", key, iv);
  let decoded = decipher.update(decrypt, "binary", "utf8");
  decoded += decipher.final("utf8");

  return decoded;
}

export function passwordToHash(data) {
  // const secret = Buffer.from(PASSWORD_SALT, "utf8");
  // const key = secret;
  // const iv = secret;

  // const cipher = crypto.createCipheriv("aes-128-cbc", key, iv);
  // let crypted = cipher.update(data, "utf8", "binary");
  // crypted += cipher.final("binary");
  // crypted = Buffer.from(crypted, "binary").toString("base64");

  // return crypted;

  return crypto.createHash("sha256").update(data).digest("hex");
}

export function hashToPassword(data) {
  const secret = Buffer.from(PASSWORD_SALT, "utf8");
  const key = secret;
  const iv = secret;

  const decrypt = Buffer.from(data, "base64").toString("binary");
  const decipher = crypto.createDecipheriv("aes-128-cbc", key, iv);
  let decoded = decipher.update(decrypt, "binary", "utf8");
  decoded += decipher.final("utf8");

  return decoded;
}
